import { render } from "./MentionList.vue?vue&type=template&id=59b9207e&scoped=true"
import script from "./MentionList.vue?vue&type=script&lang=js"
export * from "./MentionList.vue?vue&type=script&lang=js"

import "./MentionList.vue?vue&type=style&index=0&id=59b9207e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b9207e"]])

export default __exports__